const baseURL = process.env?.REACT_APP_API_URL;

export const httpStatus= {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOTFOUND: 404,
    REQUEST_TIMEOUT: 408,
    CONFLICT: 409,
    INTERNAL_SERVER_ERROR:500,
    UNAVAILABLE: 503,
    BAD_GATEWAY: 502,
    NETWORK_AUTHENTIFICATION_REQUIRED: 511
}

export const USER_ROLE = {
    PILOTE: 'Pilote',
    CONSULTANT: 'Consultant',
    BAILLEUR: 'Bailleur',
    STARTUP: 'Startup',
    ADMIN: 'Admin'
}

// export const PRESTATIONS = [
//     {
//         num: 61,
//         name: 'Services extérieurs (loyers...)',
//         value: ''
//     },
//     {
//         num: 62,
//         name: 'Autres services extérieurs (publicités...)',
//         value: ''
//     },
//     {
//         num: 63,
//         name: 'Impôts, taxes et versements assimilés',
//         value: ''
//     },
//     {
//         num: 64,
//         name: 'Charges de personnel (salaires)',
//         value: ''
//     },
//     {
//         num: 65,
//         name: 'Autres charges de gestion courante',
//         value: ''
//     },
//     {
//         num: 66,
//         name: 'Charges financières',
//         value: ''
//     },
//     {
//         num: 67,
//         name: 'Charges exceptionnelles',
//         value: ''
//     }
// ]

// export const REVENUS = [
//     {
//         num: 74,
//         name: "Subventions d'exploitation",
//         value: ''
//     },
//     {
//         num: 75,
//         name: 'Autres produits de gestion courante',
//         value: ''
//     },
//     {
//         num: 76,
//         name: 'Produits financiers',
//         value: ''
//     },
//     {
//         num: 77,
//         name: 'Produits exceptionnels',
//         value: ''
//     },
//     {
//         num: 79,
//         name: 'Transferts de charges',
//         value: ''
//     }
// ]

export const INVESTISSEMENTS = [ { }, { }, { }, { } ]

export const AMORTISSEMENS = [
    {
        numero: 14, 
        name: "Provision réglementée",
        value: '',
        typeCompte: 'credit'
    },
    {
        numero: 15,
        name: 'Provision normale',
        value: '',
        typeCompte: 'credit'
    },
    {
        numero: 28,
        name: "Amortissement d'une immobilisation",
        value: '',
        typeCompte: 'credit'
    }
]

export const ANNULATIONS = [
    {
        numero: 14, 
        name: "Provision réglementée",
        value: '',
        typeCompte: 'debit'
    },
    {
        numero: 15,
        name: 'Provision normale',
        value: '',
        typeCompte: 'debit'
    },
    {
        numero: 28,
        name: "Amortissement d'une immobilisation",
        value: '',
        typeCompte: 'debit'
    }
]

export const SOURCES = [
    {
        num: 10,
        name: "Capital et réserves (fonds propres)",
        value: ''
    },
    {
        num: 13,
        name: "Subvention d'investissement",
        value: ''
    }
]

export const TAXES = [
    {
      numero: 51,
      name: "Paiement par Banque",
      value: '',
      readOnly: false
    },
    {
      name: 'Paiement par Caisse',
      numero: 53,
      value: '',
      readOnly: false
    }
]


export const RENTABILITE_TITLES = {
    SALES_REVENUE: "(70±71) Ventes - Chiffre d'affaires",
    PRODUCTS_PURCHASED: "(60±603) Achats - Coûts des produits vendus",
    GROSS_MARGIN: "Marge brute",
    OTHER_EXTERNAL_EXPENSES: "(61+62) Autres charges externes",
    ADDED_VALUE: "Valeur ajoutée",
    OPERATING_SUBSIDIES: "(74) Subventions d'exploitation",
    TAXES_SIMILAR_PAYMENTS: "(63) Impôts, taxes et versements assimilés",
    PERSONNEL_EXPENSES: "(64) Charges de personnel",
    GROSS_OPERATING_SURPLUS: "Exédent brut d'exploitation",
    OTHER_OPERATING_INCOME: "(75 sauf 755) Autres produits de gestion courante",
    REVERSALS_AMORT_DEPREC_PROV: "(781) Reprises sur amortissements, dépréciations et provisions",
    TRANSFERS_OPERATING_EXPENSES: "(791) Transferts de charges d&apos;exploitation",
    OTHER_OPERATING_EXPENSES: "(65 sauf 655) Autres charges de gestion courante",
    DEPREC_AMORT_PROV_681: "(681) Dotations aux amortissements, dépréciations et provisions",
    OPERATING_INCOME: "Résultat d'exploitation",
    SHARE_PROFIT_JOINT_VENTURES: "(755) Quote-part de résultat sur opérations faites en commun",
    FINANCIAL_INCOME: "(76) Produits financiers",
    REVERSALS_DEPREC_PROV_786: "(786) Reprises sur dépréciations et provisions",
    FINANCIAL_EXPENSE_TRANSFERS: "(796) Transferts de charges financières",
    FINANCIAL_EXPENSES: "(66) Charges financières",
    DEPRECIATION_AMORT_PROV: "(686) Dotations aux amortissements, dépréciations et provisions",
    NET_FINANCIAL_EXPENSE: "Résultat financier",
    EXTRAORDINARY_INCOME: "(77) Produits exceptionnels",
    REVERSALS_DEPREC_PROV_787: "(787) Reprises sur dépréciations et provisions",
    TRANSFERS_EXCEPTIONAL_EXPENSES: "(797) Transferts de charges exceptionnelles",
    EXTRAORDINARY_EXPENSES: "(67) Charges exceptionnelles",
    DEPREC_AMORT_PROV: "(687) Dotations aux amortissements, dépréciations et provisions",
    NET_EXCEPTIONAL_INCOME: "Résultat exceptionnel",
    NET_INCOME: "RESULTAT NET AVANT IMPOT",
    SOCIETY_INCOME: "Impôt sur les sociétés",
    NET_AFTER_TAX_INCOME: "Résultat après Impot"
}

export const TYPE_OPERATION = {
    CAPITAL: 'Revenu supplémentaire',
    ACHAT: 'Achat',
    VENTE: 'Vente',
    PRESTATIONS: "Paiement d'une prestation ( loyers, etc...)",
    INVESTISSEMENT: 'Investissement dans votre entreprise',
    AMORTISSEMENS: 'Amortissement ou provision',
    IMPOTS: "Paiement d'un impôt ou d'une taxe"
}

export const TYPE_COMPTE = {
    DEBIT: 'debit',
    CREDIT: 'crédit'
}

export const TYPE_CLASS = {
    PASSIF_CAP: 'PASSIF CAP',
    PASSIF_RES: 'PASSIF RES',
    PASSIF_SUB: 'PASSIF SUB',
    PASSIF_DET: 'PASSIF DET',
    ACTIF_IMMO: 'ACTIF IMMO',
    ACTIF_STOCK: 'ACTIF STOCK',
    ACTIF_TIERS: 'ACTIF TIERS',
    ACTIF_FIN: 'ACTIF FIN',
}

export const TYPE_CLASS_INTITULE = {
    PASSIF_CAP: 'Capital et Réserves',
    PASSIF_RES: 'Résultat',
    PASSIF_SUB: 'Subventions',
    PASSIF_DET: 'Dettes et Provisions',
    ACTIF_IMMO: 'Immobilisations',
    ACTIF_STOCK: 'Stocks et En cours',
    ACTIF_TIERS: 'Comptes de tiers',
    ACTIF_FIN: 'Comptes financiers',
}

export const CONFIRMATION = {
    YES: 'oui',
    NO: 'non'
}

export const OPERATION_COMPTE = {
    AUGMENTER: "AUGMENTER",
    DIMINUER: "DIMINUER",
    MODIFIER: "MODIFIER"
}

export const TYPES_OPERATION = Object.values(TYPE_OPERATION);

export const API_FILE_URL = `${baseURL}file/`;

export const ROLES = Object.values(USER_ROLE);

